import { useCartStore } from '@/store/cartStore';
import { ShoppingBag01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useMemo } from 'react';
import { Button } from '../ui/button';

export function CartButton() {
  const items = useCartStore(s => s.items);
  const openCart = useCartStore(s => s.openCart);

  const itemCount = useMemo(
    () => items.reduce((sum, item) => sum + item.quantity, 0),
    [items]
  );

  return (
    <Button variant="cart" size="icon" className="relative" onClick={openCart}>
      <HugeiconsIcon icon={ShoppingBag01Icon} size={20} />
      {itemCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground w-4 h-4 rounded-full flex items-center justify-center text-xs">
          {itemCount}
        </span>
      )}
    </Button>
  );
}
